/** Matches `.submenu-item` height (`--figma-row-height`). */
const SUBMENU_ROW_HEIGHT = 56;
/** 1px rule + 8px margin on each side (`.submenu-divider`). */
const SUBMENU_DIVIDER_HEIGHT = 17;
/** Vertical padding on `.floating-submenu`. */
const SUBMENU_PAD = 32;

export function submenuContentHeight(itemCount: number, dividerCount: number): number {
  return (
    Math.max(itemCount, 1) * SUBMENU_ROW_HEIGHT +
    Math.max(dividerCount, 0) * SUBMENU_DIVIDER_HEIGHT +
    SUBMENU_PAD
  );
}

/**
 * Place a fixed flyout beside a sidebar section.
 * Opens downward from the section. When that would pass the footer or the
 * viewport, it opens upward instead — full height, no scroll.
 */
export function submenuFlyoutBox(input: {
  anchorTop: number;
  anchorBottom: number;
  contentHeight: number;
  viewportHeight: number;
  /** Top of the footer, or the viewport bottom when there is no footer. */
  footerTop: number;
  pad?: number;
}): { top: number } {
  const pad = input.pad ?? 8;
  const limitBottom = Math.min(input.viewportHeight, input.footerTop) - pad;
  const height = Math.max(input.contentHeight, 1);
  if (input.anchorTop + height <= limitBottom) {
    return { top: Math.max(pad, input.anchorTop) };
  }
  // Grow up from the section so the list stays fully visible.
  const upwardTop = Math.min(input.anchorBottom, limitBottom) - height;
  return { top: Math.max(pad, upwardTop) };
}
